import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
	display: inline-block;
	left: 50%;
	transform: translateX(-50%) !important;
	max-width: 1245px;
	width: 100%;
	.pagenum {
		display: flex;
		justify-content: center;
		align-items: center;
		max-width: 880px;
		width: 100%;
		.page-number {
			padding: 0 9px;

			ul {
				display: flex;
				gap: 8px;
				li {
					font-weight: 300;
					line-height: 30px;
					cursor: pointer;
					width: 30px;
					height: 30px;
					border-radius: 10px;
					background-color: #f7f7f7;
					text-align: center;
					font-size: 12px;
					font-weight: 300;
					text-align: center;
					&.active {
						width: 30px;
						height: 30px;
						border-radius: 10px;
						background-color: #000;
						a {
							color: #fff;
						}
					}
				}
			}
		}
	}

	.button {
		width: 10px;
		height: 8px;
		background-position: center center;
		background-repeat: no-repeat;
		cursor: pointer !important;
		transition: 0.4s;
		:hover {
			opacity: 0.6;
		}
	}
	.disable {
		:hover {
			opacity: 1;
		}
	}
	@media screen and (max-width: 768px) {
		transform: scale(0.9, 0.9);
		margin-bottom: 50px;
		.pagenum {
			margin-top: 40px;
		}
	}
`;

export const Prev = styled.div`
	background-image: url(/images/page-arrow.svg);
	background-position: center;
	transform: rotate(180deg);
	cursor: pointer;
`;
export const Prevtwo = styled.div`
	background-image: url(/images/next02.svg);
	background-position: center;
	transform: rotate(180deg);
	cursor: pointer;
	margin-left: 25px;
	position: relative;
	left: -20px;
`;

export const Next = styled.div`
	background-image: url(/images/page-arrow.svg);
	background-position: center;
	cursor: pointer;
`;

export const Nexttwo = styled.div`
	background-image: url(/images/next02.svg);
	background-position: center;
	cursor: pointer;
	margin-left: 25px;
`;
